import { render } from "./Reservation.vue?vue&type=template&id=06658570&scoped=true"
import script from "./Reservation.vue?vue&type=script&lang=js"
export * from "./Reservation.vue?vue&type=script&lang=js"

import "./Reservation.vue?vue&type=style&index=0&id=06658570&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06658570"]])

export default __exports__